import { InjectionToken } from "@angular/core";
import { isProduction } from "./environment";

export const DEBUG_VALUE = true;
export const DEBUG = new InjectionToken<string>('DEBUG_MODE');

export const CALLABLE_2ND_GEN_BASE_URL_VALUE = isProduction() ? 
"https://callablesv2-ko2ie6hrdq-uc.a.run.app" :
"https://callablesv2-lnwjdjesfa-uc.a.run.app";

export const CALLABLE_2ND_GEN_BASE_URL = new InjectionToken<string>("CALLABLE_2ND_GEN_BASE_URL");

// Si se elecuta cloud functions de 1er o 2da generación
export const CALLABLE_GENERATION_VERSION_VALUE = 2;
export const CALLABLE_GENERATION_VERSION = new InjectionToken<string>("CALLABLE_GENERATION_VERSION");

export const GOOGLE_MAP_API_KEY_VALUE = 'AIzaSyDNdxzRrKtQrepUZdNHThwQ3MLYD7sRDDY';
export const GOOGLE_MAP_API_KEY = new InjectionToken<string>('GOOGLE_MAP_API_KEY');